'use client';

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Fragment } from 'react';

import { Button, ButtonProps } from '@/shared';

export type DropdownConfirmProps = React.PropsWithChildren & {
	anchor?: 'bottom start' | 'bottom end' | 'top start' | 'top end';
	variant?: ButtonProps['variant'];
	size?: ButtonProps['size'];
	text?: string;
	confirmVariant?: ButtonProps['variant'];
	confirmText?: string;
	cancelText?: string;
	onConfirm: () => void;
};

export const DropdownConfirm = ({
	anchor = 'bottom end',
	variant,
	size,
	text = 'Вы уверены?',
	confirmVariant = 'green',
	confirmText = 'Подтвердить',
	cancelText = 'Отменить',
	children,
	onConfirm,
}: DropdownConfirmProps) => {
	return (
		<Menu>
			<MenuButton as={Fragment}>
				{() => (
					<Button type="button" size={size} variant={variant}>
						{children}
					</Button>
				)}
			</MenuButton>
			<MenuItems
				anchor={anchor}
				transition
				className="z-50 flex flex-row flex-nowrap items-center gap-2 rounded-lg bg-white p-2 shadow-listbox ring-1 ring-inset ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
			>
				<span className="text-sm">{text}</span>
				<MenuItem>
					{({ close }) => (
						<Button
							type="button"
							size="28"
							variant="plain-gray"
							onClick={close}
						>
							{cancelText}
						</Button>
					)}
				</MenuItem>
				<Button
					type="button"
					size="28"
					variant={confirmVariant}
					onClick={onConfirm}
				>
					{confirmText}
				</Button>
			</MenuItems>
		</Menu>
	);
};
